import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import Button from '../../../../components/Button'
import RightArrowIcon from '../../../../components/icons/RuleEngineTableIcons/RightArrowIcon'
import { StyledTableSqare } from '../../../../components/TableStyles/TableStylesSqare/TableStylesSqare'

export const DashboardTopHeader = styled(Flex)`
  position: relative;
  width: 100%;
  font-size: 16px;
  font-weight: ${FONT.FW_700};
  color: ${COLORS.GREY_P_100};
`

export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: ${FONT.F_XL};
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`

export const SetRoleHeader = styled(Flex)`
  color: ${props => (props.Style ? 'rgba(37, 99, 235, 1)' : 0)}!important;
  padding-top: ${props => (props.Style ? '10px' : '20px')};
  position: relative;
  width: 100%;
  font-weight: ${FONT.FW_700};
  color: ${COLORS.GREY_P_100};
  font-size: 14px;
`

export const SetRoleDiv = styled.div`
  display: ${({ enable }) =>
    enable === false ? 'block' : 'flex'}; /* Fallback to block when not flex */
  display: ${props => (props.enable == false ? '' : 'flex')};
  margin-top: ${props => (props.enable ? '20px' : '5px')};
  font-weight: ${props => props.RuleSetStyle && '500'};
  color: ${props =>
    props.RuleSetStyle ? 'rgba(77, 86, 110, 1)' : '#4D566E'}!important;
  flex-direction: row;
  font-weight: ${FONT.FW_400};
  font-size: 14px;
  line-height: 20px;
  color: ${({ color }) => color || COLORS.GREY_T_60};
`
export const ModalOverlay = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

export const ModalBox = styled.div`
  background: white;
  padding: 20px 40px;
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  width: 742px;
  height: 340px;
  max-width: 90%;
  text-align: center;
`

export const PopUpBox = styled.div`
  background: white;
  padding-left: ${props => (props.isExpanded ? '40px' : '200px')};
  padding-top: ${props => (props.isExpanded ? '10px' : '30px')};
  padding-right: ${props => (props.isExpanded ? '40px' : 0)};
  border: 1px solid #e6e7ea;
  border-radius: ${props => (props.isExpanded ? '20px 0px 0px 0px' : '10px')};
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  width: ${props => (props.isExpanded ? '1313px' : '828px')};
  height: ${props => (props.isExpanded ? '700px' : '510px')};
  max-width: 90%;
  text-align: center;
  opacity: ${props => (props.isExpanded ? '1' : 'unset')};
  transition: all 0.3s ease-in-out;

  /* Scroll Behavior */
  overflow-y: ${props => (props.isExpanded ? 'auto' : 'unset')};
  overflow-x: hidden;

  /* Ensure the content inside doesn't expand beyond the box */
  max-height: ${props => (props.isExpanded ? '700px' : 'unset')};

  /* Optional: Smooth scrolling for better UX */
  scrollbar-width: thin; /* For Firefox */
  scrollbar-color: #c0c0c0 #e6e7ea; /* Thumb and track colors */

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c0c0c0;
    border-radius: 10px;
  }
`

export const PopUpContainer = styled('div')(() => ({
  background: 'white',
  // width: '828px',
  borderRadius: 10,
  border: '1px solid #E6E7EA',
  paddingTop: 20,
  paddingBottom: 20,
}))

export const PopUpTitle = styled.h2`
  font-family: 'Plus Jakarta Sans';
  font-weight: 900;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: #000;
  margin-bottom: 24px;
`
export const PopupText = styled.h2`
  font-family: Plus Jakarta Sans;
  font-size: 18px;
  font-weight: 400px;
  font-weight: ${props => props.fontWeight || '500'};
  line-height: 28px;
  text-align: left;
  color: #010e30;
  display: flex;
  font-size: 15px;
  justify-content: space-between;
  margin: 0;
`
export const PopupContent = styled.h2`
  margin-top: 10px;
  font-family: Plus Jakarta Sans;
  font-size: ${props => props.fontSize || '15px'};
  font-weight: ${props => props.fontWeight || '700'};
  line-height: 28px;
  text-align: ${props => props.textAlign || 'center'};
  color: #010e30;
`
export const ViewText = styled.a`
  font-weight: 800;
  color: #3249d7;
  text-decoration: none;
  font-size: 15px;
  white-space: nowrap;
  &:hover {
    text-decoration: none;
    color: #3249d7;
  }
`

export const PopUpContent = styled.p`
  font-family: 'Plus Jakarta Sans';
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: #010e30;
  text-align: left;
  margin-bottom: 12px;
`
export const Box = styled.div`
  display: flex;
  padding: 18px;
  border: 0.5px solid #3249d7;
  box-shadow: 0px 4px 4px 0px #00000026;
  border-radius: 15px;
  width: fit-content;
  height: 113px;
  padding-left: 20px;
  padding-right: 40px;
  background-color: white !important;
`

export const BoxContent = styled.div`
  display: flex;
  flex-direction: column;
  border-right: ${({ noBorderRight }) =>
    noBorderRight ? 'none' : '1px solid #e6e6e6'};
  align-items: flex-start;
  justify-content: center;
  padding-right: ${props => (props?.pRight ? props?.pRight : 'inherit')};
  margin-right: ${props => (props?.mRight ? props?.mRight : 'inherit')};
`

export const DropdownBox = styled.div`
  background-color: ${({ selected }) => (selected ? '#3249D7' : '#F4F4FF')};
  cursor: ${props => (props.readonly ? 'not-allowed' : 'pointer')};
  pointer-events: ${props => (props.readonly ? 'none' : 'unset')};
  border-radius: 8px;
  padding: ${({ padding }) => padding || '16px 24px'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  height: 87px;
  color: black;
  font-family: 'Plus Jakarta Sans';
`

export const DropdownLabel = styled.p`
  font-size: 16px;
  font-weight: 700;
  color: ${({ selected }) =>
    selected
      ? '#FFFFFF'
      : '#3249D7'}!important; /* Conditional color based on selected */
  margin: 0;
`
export const DropdownSelect = styled.select`
  background: #f4f4ff;
  color: black;
  border-radius: 8px;
  border: none;
  padding: 8px;
  font-size: 16px;
  font-family: 'Plus Jakarta Sans';
  cursor: pointer;
`

export const Option = styled.option`
  font-size: 16px;
`
export const ViewLink = styled.a`
  font-size: 14px;
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
  margin-top: 10px;
`
export const Title = styled.h2`
  justify-content: space-between;
  font-family: 'Plus Jakarta Sans';
  font-weight: 700;
  font-size: 18px;
  line-height: 10px;
`
export const Span = styled.span`
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  text-align: ${({ textAlign }) =>
    textAlign || 'left'}; /* Default to left alignment */
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px; /* Adjusted font-size */
  line-height: 1.5; /* Line-height for improved readability */
  color: ${({ color }) => color || '#1e1e1e'}; /* Default to dark color */
  white-space: ${({ nowrap }) => (nowrap ? 'nowrap' : 'normal')};
`
export const SearchByKeywords = styled.input`
  width: 550px;
  height: 43px;
  padding: 10px 15px;
  margin-bottom: 20px;
  border: 1px solid #d6dbf7;
  border-radius: 10px;
  font-size: 12px;
  color: #000;
  font-weight: 500;
  box-shadow: 0px 2px 6px 0px #7b61ff26;

  ::placeholder {
    color: #888888;
  }

  &:focus {
    outline: none;
    border-color: #d6dbf7;
  }
`

export const ClearButton = styled.button`
  font-family: 'Plus Jakarta Sans';
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  background: #e35e50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
`
export const TableHeader = styled.tr`
  width: 1100px;
  display: flex;
  justify-content: space-between;
  text-align: left;
  padding: 0;
  border: none;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;
`
export const DraftPagecontent = styled.div`
  display: flex;
  justifycontent: space-between;
  alignitems: center;
  padding: '30px 205px 0 0';
`

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`

export const RoleButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 11px;
  padding-bottom: 20px;
`
export const StyledButton = styled.button`
  background-color: ${({ selected }) => (selected ? '#3249D7' : '#FFFFFF')};
  color: ${({ selected }) => (selected ? '#FFFFFF' : '#000000')};
  border: 1px solid #e0e0e0;
  box-shadow: none;
  margin-right: 8px;
  padding: 8px 16px;
  cursor: pointer;
  border-radius: 10px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  width: 8em;
  height: 3.1em;
  white-space: nowrap;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'unset')};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${({ selected }) => (selected ? '#3249D7' : '#F0F0F0')};
  }
`

export const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const PopTitle = styled.h2`
  padding-top: 15px;
  font-weight: 700;
  color: #010e30;
  text-align: center;
  font-size: 20px;
  margin-bottom: 30px;
`

export const ButtonContainer = styled.div`
  // padding-right: 200px;
  padding-right: ${props => props.paddingRight || '200px'};
  padding-left: ${props => props.paddingLeft || '200px'};
  display: flex;
  justify-content: ${props =>
    props?.justify ? props?.justify : ' center'}; /* Centering the buttons */
  padding-top: 20px; /* Added top padding */
  gap: 20px; /* Added gap for spacing between buttons */
`
export const SecondaryButton = styled(Button.Secondary)`
  // color: ${props => props.fontColor || '#000'};
  // width: 100px;
  width: ${props => props.Width || '100px'};
`
export const PrimaryButton = styled(Button.Primary)`
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 10px;
`

export const SearchInput = styled.input`
  padding-bottom: 0px;
  border: none;
  background: none;
  outline: none;
  font-size: 14px;
  color: #333;
  width: 100%;

  &::placeholder {
    color: #aaa;
  }
`
export const FullDivCenterFlex = styled.div`
  display: flex;
  justify-content: ${({initialState}) => initialState ? "flex-end":" space-between"};
  width: 95%;
  flex-wrap: wrap;
  padding-bottom: 20px;
`

export const SetLink = styled.h3`
  font-weight: bold;
  color: #3249d7;
  display: flex;
  align-items: center;
`

export const DeleteLink = styled.div`
  color: red;
  cursor: pointer;
`

export const DegreeDepartmentWrapper = styled.div`
  // white-space: pre-line; /* Allows multi-line text */
  padding: 20px;
  white-space: nowrap;
`

export const RulesActiveWrapper = styled.div`
  white-space: pre-line;
  padding: 20px;
  a {
    color: #3249d7;
    cursor: pointer;
  }
`

export const DateText = styled.div`
  font-size: 12px;
  color: #999;
`

export const SetContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
export const RERightArrowIcon = styled(RightArrowIcon)`
  font-size: 12px;
  margin-left: 4px;
`
export const BoldBlueText = styled.span`
  font-weight: bold;
  color: blue;
`
export const TableDiv = styled.div`
  padding-top: 10px;
  width: 100%;
`
export const SearchAndCountWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100% !important;
`
export const ImageContainer = styled.div`
  text-align: center;
  margin-top: 50px;
  //  width: 361px;
  //  margin-bottom: 20px;
  height: 380px;
`
export const ContentCenterDiv = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 10px;
  width: 95%;
  text-align: center;
`

export const SetColDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: -webkit-fill-available;
  margin-top: 30px;
`
export const DepartmentTableDiv = styled.div`
  width: 95%;
`
  export const StyledTableSqareUpdate = styled(StyledTableSqare)`
    .ant-table-container table > thead > tr:first-child th:first-child,
    .ant-table-container table > tbody > tr td:first-child {
      padding-left: 0px;
    }
    .ant-table-cell {
      height: 0%;
    }

    .ant-table-thead > tr:first-child > th {
      background-color: #f0f0f0 !important;
      font-weight: bold;
    }
    .ant-checkbox-wrapper {
      display: flex;
      justify-content: center;
    }

    .ant-table-row {
      height: 55px;
    }

    .ant-input {
      margin-bottom: 16px;
      width: 100%;
      max-width: 300px;
    }

    .ant-pagination {
      display: flex;
      justify-content: center;
      margin-top: 16px;
    }
`

export const TotalHeader = styled.p`
  font: Plus Jakarta Sans;
  color: #000000;
  font-weight: bold;
`
export const DisplayImage = styled.div`
  width: 156px;
  height: 197px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const ruleItemStyle = {
  display: 'flex',
  // justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '5px',
  gap: '4px',
  whiteSpace: 'nowrap',
}

export const countStyle = {
  fontWeight: 'bold',
  fontSize: '14px',
  color: '#2563EB', // Blue color for the count
}
export const StyledTableNew = styled(StyledTableSqareUpdate)`
  .ant-table-container table > thead > tr:first-child th:first-child,
  .ant-table-container table > tbody > tr td:first-child {
    padding: 0px;
  }
`
